import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="pt-40 pb-24 px-6" data-id="element-52">
      <div className="max-w-3xl mx-auto text-center" data-id="element-53">
        <h1 className="font-serif text-6xl md:text-7xl lg:text-8xl leading-[1.1] tracking-tight mb-8" data-id="element-54">
          {t.hero.headlineLine1} <br data-id="element-55" />
          <span className="italic text-coral" data-id="element-56">{t.hero.headlineLine2}</span>
        </h1>

        <div className="space-y-6 text-lg md:text-xl text-ink/80 max-w-2xl mx-auto leading-relaxed" data-id="element-57">
          <p data-id="element-58">
            {t.hero.p1Before}
            <em data-id="element-59">{t.hero.p1Italic}</em>
            {t.hero.p1After}
          </p>

          <p data-id="element-60">{t.hero.p2}</p>

          <p data-id="element-61">{t.hero.p3}</p>

          <p data-id="element-62">{t.hero.p4}</p>

          <p className="font-serif text-3xl italic text-ink pt-4" data-id="element-63">
            {t.hero.untilNow}
          </p>
        </div>

        <div className="mt-12" data-id="element-64">
          <button type="button" className="inline-flex items-center justify-center px-10 py-5 bg-[#FF1F3D] text-white font-semibold text-xl md:text-2xl rounded-full shadow-[0_0_30px_rgba(255,31,61,0.6)] hover:bg-[#FF0033] hover:shadow-[0_0_45px_rgba(255,31,61,0.85)] transition-all hover:scale-105 active:scale-95" data-id="element-65">
            {t.hero.cta}
          </button>
        </div>
      </div>
    </section>;
}